import Vue from "vue";
import VueSocketIO from "vue-socket.io";
import io from "socket.io-client";

Vue.use(
  new VueSocketIO({
    debug: true,
    connection: io("https://api.heig-vd.ch/bulletin-heg", {
      path: "/bulletin-heg/socket.io",
      transport: ["websocket"],
    }),
  })
);